import { render, staticRenderFns } from "./type4.vue?vue&type=template&id=06011c6a&scoped=true&"
import script from "./type4.vue?vue&type=script&lang=ts&"
export * from "./type4.vue?vue&type=script&lang=ts&"
import style0 from "./type4.vue?vue&type=style&index=0&id=06011c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06011c6a",
  null
  
)

export default component.exports